import { createContext } from "react";

const ContextConfirm = createContext(null)

export {ContextConfirm}